import { BookingLanguage } from "@/types/booking";
import { t } from "@/locales";

export const getTranslations = (language: BookingLanguage) => {
  return {
    title: t(language, "clinicStep.title"),
    subtitle: t(language, "clinicStep.subtitle"),
    continue: t(language, "common.continue"),
    back: t(language, "common.back"),
    loading: t(language, "clinicStep.loading"),
    notAvailable: t(language, "clinicStep.notAvailable"),
    removeProduct: t(language, "clinicStep.removeProduct"),
    makeAvailable: t(language, "clinicStep.makeAvailable"),
    selectLocation: t(language, "clinicStep.selectLocation"),
    locationSelected: t(language, "clinicStep.locationSelected"),
    openInMaps: t(language, "clinicStep.openInMaps"),
    operatedBy: t(language, "clinicStep.operatedBy"),
    openHours: t(language, "clinicStep.openHours"),
    openHoursSat: t(language, "clinicStep.openHoursSat"),
    mon: t(language, "clinicStep.mon"),
    tue: t(language, "clinicStep.tue"),
    wed: t(language, "clinicStep.wed"),
    thu: t(language, "clinicStep.thu"),
    fri: t(language, "clinicStep.fri"),
    sat: t(language, "clinicStep.sat"),
    sun: t(language, "clinicStep.sun"),
    unavailableSuffix: t(language, "clinicStep.unavailableSuffix"),
    maps: t(language, "clinicStep.maps"),
    regionZhKanton: t(language, "clinicStep.region.zhKanton"),
    regionZentralschweiz: t(language, "clinicStep.region.zentralschweiz"),
    regionNordwestschweiz: t(language, "clinicStep.region.nordwestschweiz"),
    regionMittelland: t(language, "clinicStep.region.mittelland"),
    regionOstschweiz: t(language, "clinicStep.region.ostschweiz"),
    regionWestschweiz: t(language, "clinicStep.region.westschweiz"),
    regionOther: t(language, "clinicStep.region.other"),
  };
};
